import DemoReportsTableFilter from './DemoReportsTableFilter'

export default DemoReportsTableFilter
